import React from 'react';
import PropTypes from 'prop-types';
import TermLengthStackedButton from '../TermLengthCalculator/TermLengthStackedButton';

export default function TermInsuranceTermLengthTool(props) {
  const { toolName, title, insuredAge, onTermLengthCalculation } = props;

  return (
    <TermLengthStackedButton
      type='quote-screen'
      condensed
      toolName={toolName}
      title={title}
      isCustomTerm={true}
      insuredAge={insuredAge}
      onTermLengthCalculation={onTermLengthCalculation}
    />
  );
};

TermInsuranceTermLengthTool.propTypes = {
  toolName: PropTypes.string,
  title: PropTypes.string,
  insuredAge: PropTypes.number,
  onTermLengthCalculation: PropTypes.func,
};
